var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSedanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "28px",
    viewBox: "0 0 50 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sedanIcon",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.21875,0 C13.484375,0 11.890625,0.871094 10.96875,2.34375 L7.40625,8.0625 L4.28125,8.53125 C1.835938,8.882813 0,10.996094 0,13.46875 L0,20 C0,21.652344 1.347656,23 3,23 L5.09375,23 C5.574219,25.832031 8.03125,28 11,28 C13.96875,28 16.425781,25.832031 16.90625,23 L33.09375,23 C33.574219,25.832031 36.03125,28 39,28 C41.96875,28 44.429688,25.832031 44.90625,23 L47,23 C48.652344,23 50,21.652344 50,20 L50,14.375 C50,11.921875 48.234375,9.871094 45.8125,9.46875 L37.5625,8.09375 L33,2 C32.0625,0.746094 30.566406,0 29,0 L15.21875,0 Z M15.21875,2 L21,2 L21,8 L9.8125,8 L12.6875,3.40625 C13.238281,2.523438 14.179688,2 15.21875,2 Z M23,2 L29,2 C29.9375,2 30.84375,2.4375 31.40625,3.1875 L35,8 L23,8 L23,2 Z M11,18 C13.207031,18 15,19.792969 15,22 C15,24.207031 13.207031,26 11,26 C8.792969,26 7,24.207031 7,22 C7,19.792969 8.792969,18 11,18 Z M39,18 C41.207031,18 43,19.792969 43,22 C43,24.207031 41.207031,26 39,26 C36.792969,26 35,24.207031 35,22 C35,19.792969 36.792969,18 39,18 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSedanIcon);
export default __webpack_public_path__ + "static/media/sedanIcon.0e084331f969551d84738ff3f02c8285.svg";
export { ForwardRef as ReactComponent };